<template>
  <b-button-group size="sm" class="p-1" >
    <b-button pill variant="primary" v-b-tooltip.hover title="Visualizar ou Editar"
        @click="viewItem"
        >
        <b-icon style="width: 0.8rem;" icon="pencil-fill" />
    </b-button>
    <b-button pill variant="info" v-b-tooltip.hover title="Copiar o Item" class="mx-1" 
        @click="copyItem">
        <b-icon style="width: 0.9rem;" icon="file-plus" />
    </b-button>
  </b-button-group>
</template>

<script>

export default {
    props:["rowItem", "rowIndex", "target"],
    methods:{
        viewItem() {
            this.$emit("viewItem", { target: this.rowItem, index: this.rowIndex })
        },
        copyItem() {
            
            const item = JSON.parse(JSON.stringify(this.rowItem));
            item.productName = item.productName + " Copy";
            
            
            this.$emit("copyItem", { target: item, index: this.rowIndex })
        }
    }
}
</script>

<style>

</style>